module.exports = __webpack_public_path__ + "static/sandishu.d607ac76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sandishu.png
// module id = TjQj
// module chunks = 0